import { render, staticRenderFns } from "./features.vue?vue&type=template&id=42ecfdfc&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ecfdfc",
  null
  
)

export default component.exports